import { render, staticRenderFns } from "./CombinedSalaryDataTableRow.vue?vue&type=template&id=3bf4c4bc"
import script from "./CombinedSalaryDataTableRow.vue?vue&type=script&lang=js"
export * from "./CombinedSalaryDataTableRow.vue?vue&type=script&lang=js"
import style0 from "./CombinedSalaryDataTableRow.vue?vue&type=style&index=0&id=3bf4c4bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports